import { DataTableV2, Intro } from "components/commons";
import { locale } from "localization/en";
import { useRouter } from "hooks";
import { orderSummaryColumn } from "./order-summary-list-column";
import { mapDataToList, mapFilterToRequest } from "./order-summary-list-mapper";
import { getOrderSummaryListApi } from "apis";
import { initialFilterState } from "./order-summary-filter.state";
import useDataTable from "hooks/useDataTable";
import OrderSummaryFilter from "./order-summary-filter";

const OrderSummaryModule = () => {
  const { history } = useRouter();

  const { filter, search, table } = useDataTable({
    api: {
      api: getOrderSummaryListApi,
      params: {
        page: 1,
        perPage: 10,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: {
      initialState: initialFilterState(),
      mapper: mapFilterToRequest,
      disregardFilterCount: {
        dateBy: true,
      },
    },
    table: {
      key: "orders",
      mapper: (orders) =>
        mapDataToList({
          orders,
          history,
        }),
      columns: orderSummaryColumn,
    },
  });

  return (
    <div>
      <Intro title={locale.orderSummary} />
      <OrderSummaryFilter {...filter} {...search} />
      <DataTableV2 {...table} />
    </div>
  );
};

export default OrderSummaryModule;
